import { Box, Stack, Breadcrumbs, Typography } from '@mui/material'
import theme from 'candidate/theme'
import { Link } from 'react-router-dom'
import { recruiterRouteConfig } from 'recruiter/routes'
import { getPxAsRem } from 'shared/utils'
import { DesktopHeader } from '../styled'
import { GetCompanyClientsQuery } from '__generated__/graphql'

export interface PermissionsHeaderProps {
    data: GetCompanyClientsQuery | undefined
}

const PermissionsHeader: React.FC<PermissionsHeaderProps> = ({ data }) => {
    const header = (
        <DesktopHeader disableGutters maxWidth={false}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: getPxAsRem(24, 48),
                }}
            >
                <Stack direction="column" spacing={2}>
                    <Breadcrumbs>
                        <Link
                            to={`${recruiterRouteConfig.companies.path}/${data?.company.id}`}
                            style={{ textDecoration: 'none' }}
                        >
                            <Typography
                                sx={{
                                    color: theme.palette.text.primary,
                                    opacity: 0.6,
                                    variant: 'h3',
                                }}
                            >
                                {data?.company.value}
                            </Typography>
                        </Link>
                        <Typography
                            sx={(theme) => ({
                                color: theme.palette.primary.main,
                                variant: 'h3',
                            })}
                        >
                            Client Permissions
                        </Typography>
                    </Breadcrumbs>
                    <Stack direction="column" spacing={1}>
                        <Typography variant="h2">Client Permissions</Typography>
                        <Stack direction="row" spacing={2}>
                            <Stack direction="column" spacing={1}>
                                <Typography variant="bodySans1">
                                    Total Users
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight="fontWeightMedium"
                                >
                                    {data?.company?.clients?.length ?? -1}
                                </Typography>
                            </Stack>
                            <Stack direction="column" spacing={1}>
                                <Typography variant="bodySans1">
                                    Admin
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight="fontWeightMedium"
                                >
                                    {data?.company?.adminClient?.user
                                        ?.preferredName ?? '-'}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </DesktopHeader>
    )
    return header
}

export default PermissionsHeader
